﻿import { createContext } from "react";
import {WizardValues} from "./WizardValues";

export const WizardContext = createContext<WizardValues | null>(null);
